import i18n from "i18next"
import { initReactI18next } from "react-i18next"

import CNzhAutoGenerated from "./assets/json/language/Autogenerated/CNzh.json"
import CNzhMisc from "./assets/json/language/Translated/CNzh.json"

import EUdeAutoGenerated from "./assets/json/language/Autogenerated/EUde.json"
import EUdeMisc from "./assets/json/language/Translated/EUde.json"

import EUesAutoGenerated from "./assets/json/language/Autogenerated/EUes.json"
import EUesMisc from "./assets/json/language/Translated/EUes.json"

import EUenAutoGenerated from "./assets/json/language/Autogenerated/EUen.json"
import EUenMisc from "./assets/json/language/Translated/EUen.json"

import EUfrAutoGenerated from "./assets/json/language/Autogenerated/EUfr.json"
import EUfrMisc from "./assets/json/language/Translated/EUfr.json"

import EUitAutoGenerated from "./assets/json/language/Autogenerated/EUit.json"
import EUitMisc from "./assets/json/language/Translated/EUit.json"

import EUnlAutoGenerated from "./assets/json/language/Autogenerated/EUnl.json"
import EUnlMisc from "./assets/json/language/Translated/EUnl.json"

import EUruAutoGenerated from "./assets/json/language/Autogenerated/EUru.json"
import EUruMisc from "./assets/json/language/Translated/EUru.json"

import JPjaAutoGenerated from "./assets/json/language/Autogenerated/JPja.json"
import JPjaMisc from "./assets/json/language/Translated/JPja.json"

import KRkoAutoGenerated from "./assets/json/language/Autogenerated/KRko.json"
import KRkoMisc from "./assets/json/language/Translated/KRko.json"

import TWzhAutoGenerated from "./assets/json/language/Autogenerated/TWzh.json"
import TWzhMisc from "./assets/json/language/Translated/TWzh.json"

import USenAutoGenerated from "./assets/json/language/Autogenerated/USen.json"
import USenMisc from "./assets/json/language/Translated/USen.json"

import USesAutoGenerated from "./assets/json/language/Autogenerated/USes.json"
import USesMisc from "./assets/json/language/Translated/USes.json"

import USfrAutoGenerated from "./assets/json/language/Autogenerated/USfr.json"
import USfrMisc from "./assets/json/language/Translated/USfr.json"

import PTBRMisc from "./assets/json/language/Translated/PTbr.json"

import CNzhOther from "./assets/json/language/Other/CNzh.json"
import EUdeOther from "./assets/json/language/Other/EUde.json"
import EUenOther from "./assets/json/language/Other/EUen.json"
import EUesOther from "./assets/json/language/Other/EUes.json"
import EUfrOther from "./assets/json/language/Other/EUfr.json"
import EUitOther from "./assets/json/language/Other/EUit.json"
import EUnlOther from "./assets/json/language/Other/EUnl.json"
import EUruOther from "./assets/json/language/Other/EUru.json"
import JPjaOther from "./assets/json/language/Other/JPja.json"
import KRkoOther from "./assets/json/language/Other/KRko.json"
import TWzhOther from "./assets/json/language/Other/TWzh.json"
import USenOther from "./assets/json/language/Other/USen.json"
import USesOther from "./assets/json/language/Other/USes.json"
import USfrOther from "./assets/json/language/Other/USfr.json"

import LanguageDetector from "i18next-browser-languagedetector"
// not like to use this?
// have a look at the Quick start guide
// for passing in lng and translations on init

i18n
    // detect user language
    // learn more: https://github.com/i18next/i18next-browser-languageDetector
    .use(LanguageDetector)
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
        fallbackLng: "en",
        debug: false,
        languages: [
            "de",
            "en",
            "es",
            "jp",
            "kr",
            "zh-CN",
            "it",
            "fr",
            "ru",
            "zh-TW",
            "en-US",
            "fr-US",
            "es-MX",
            "nl",
            "pt-BR",
        ],
        resources: {
            en: {
                translation: EUenAutoGenerated,
                misc: EUenMisc,
                other: EUenOther,
            },
            de: {
                translation: EUdeAutoGenerated,
                misc: EUdeMisc,
                other: EUdeOther,
            },
            es: {
                translation: EUesAutoGenerated,
                misc: EUesMisc,
                other: EUesOther,
            },
            fr: {
                translation: EUfrAutoGenerated,
                misc: EUfrMisc,
                other: EUfrOther,
            },
            it: {
                translation: EUitAutoGenerated,
                misc: EUitMisc,
                other: EUitOther,
            },
            kr: {
                translation: KRkoAutoGenerated,
                misc: KRkoMisc,
                other: KRkoOther,
            },
            "zh-CN": {
                translation: CNzhAutoGenerated,
                misc: CNzhMisc,
                other: CNzhOther,
            },
            jp: {
                translation: JPjaAutoGenerated,
                misc: JPjaMisc,
                other: JPjaOther,
            },
            nl: {
                translation: EUnlAutoGenerated,
                misc: EUnlMisc,
                other: EUnlOther,
            },
            ru: {
                translation: EUruAutoGenerated,
                misc: EUruMisc,
                other: EUruOther,
            },
            "zh-TW": {
                translation: TWzhAutoGenerated,
                misc: TWzhMisc,
                other: TWzhOther,
            },

            "en-US": {
                translation: USenAutoGenerated,
                misc: USenMisc,
                other: USenOther,
            },
            "es-MX": {
                translation: USesAutoGenerated,
                misc: USesMisc,
                other: USesOther,
            },
            "fr-CA": {
                translation: USfrAutoGenerated,
                misc: USfrMisc,
                other: USfrOther,
            },
            "pt-BR": {
                translation: USenAutoGenerated,
                misc: PTBRMisc,
                other: USenOther,
            },
        },
        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        },
    })

export default i18n
